import EmblaCarousel from "embla-carousel";

/**
 * Initializes the Embla Carousel
 * @param {HTMLElement} emblaNode - The root element (.embla)
 * @param {Object} customOptions - Optional overrides for Embla
 */
export const initGallery = (emblaNode = {}) => {
  if (!emblaNode) return null;

  const options = {
    align: "start", // Aligns the active slide to the left edge
    containScroll: "trimSnaps", // Prevents extra whitespace at the end
    loop: true,
  };

  const emblaApi = EmblaCarousel(emblaNode, options);

  // Find buttons relative ONLY to this specific gallery instance
  // This assumes your buttons are siblings or children of the .embla node
  const parent = emblaNode.parentElement;
  const prevBtn = parent.querySelector(".embla__prev");
  const nextBtn = parent.querySelector(".embla__next");

  if (prevBtn) prevBtn.addEventListener("click", () => emblaApi.scrollPrev());
  if (nextBtn) nextBtn.addEventListener("click", () => emblaApi.scrollNext());

  return emblaApi;
};
